import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import classNames from 'classnames'; // import dateFormat from 'dateformat';

import { useLogin } from '../reactHooks.js';
import './mainMenu.scss';

function MainMenu(props) {
  var {
    menuItems,
    title,
    type = 'dark'
  } = props;
  var [menuOpen, setMenuOpen] = useState(false);
  var login = useLogin();
  var urlParams = useParams();
  var {
    homePath
  } = urlParams;
  var menuOverlay = true;
  let menuItemsToUse = Object.entries(menuItems).filter(([, item]) => {
    if (typeof item.shouldShow === 'function') {
      return item.shouldShow();
    } else if (typeof item.shouldShow === 'boolean') {
      return item.shouldShow;
    }

    return true;
  }).map(([itemKey, item]) => ({ ...item,
    key: itemKey
  }));

  var closeMenu = () => menuOverlay && setMenuOpen(false);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classNames(`mainToolBar noSelect ${type}`, {
      menuOpen
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "mainMenuButton",
    onClick: () => setMenuOpen(!menuOpen)
  }, "Menu"), /*#__PURE__*/React.createElement("div", {
    className: "titleBar"
  }, title || location.hostname), login?.loggedIn && /*#__PURE__*/React.createElement("div", {
    className: "logoutButton",
    onClick: () => login.logout()
  }, "Logout")), /*#__PURE__*/React.createElement("div", {
    className: classNames(`mainMenu ${type}`, {
      menuOpen,
      menuOverlay
    })
  }, /*#__PURE__*/React.createElement(Link, {
    className: "menuItem",
    to: '/',
    onClick: closeMenu
  }, "Home"), menuItemsToUse.map(item => /*#__PURE__*/React.createElement(Link, {
    className: classNames('menuItem', {
      selected: homePath === item.key
    }),
    key: item.key,
    to: `/${item.key}`,
    onClick: closeMenu
  }, item.title))));
}

export default MainMenu;